/** Constrains `value` to the inclusive range `[min, max]`. */
export const clamp = (value: number, min: number, max: number): number => Math.max(min, Math.min(max, value))

/**
 * Reads typed text as a whole number of 1 or more: digits only after trimming, and small enough
 * to be represented exactly. Returns `null` for anything else, including digit strings that
 * `Number()` turns into `Infinity` or rounds.
 */
export const parseWholePositive = (text: string): number | null => {
  const trimmed = text.trim()
  if (!/^\d+$/.test(trimmed)) return null

  const value = Number(trimmed)
  return Number.isSafeInteger(value) && value > 0 ? value : null
}

/**
 * The next multiple of `step` above `value`, held at `max`: with a step of 50, 6 goes to 50 and 956
 * to 999 when 999 is the most allowed, so round values and the maximum can always be reached.
 */
export const stepUp = (value: number, step: number, max: number): number =>
  Math.min(max, (Math.floor(value / step) + 1) * step)

/** The previous multiple of `step` below `value`, held at `min`: 100 goes to 50, and 50 to 1 when 1 is the least allowed. */
export const stepDown = (value: number, step: number, min: number): number =>
  Math.max(min, (Math.ceil(value / step) - 1) * step)
